import { BaseAPI } from './BaseAPI.js'
import { Team } from '../types/index.js'

export default class TeamAPI extends BaseAPI<Team> {
  override get resource(): string {
    return '/teams'
  }
}
